"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastsHandlerBase = void 0;
const toasts_constants_1 = require("../toasts.constants");
const toast_handler_item_model_1 = require("./toast-handler-item.model");
class ToastsHandlerBase {
    constructor(window, eventName = toasts_constants_1.ToastsConstants.TOAST_EVENT_NAME) {
        this.eventName = toasts_constants_1.ToastsConstants.TOAST_EVENT_NAME;
        this.toasts = {};
        this.window = window;
        if (!!eventName) {
            this.eventName = eventName;
        }
        this.window.addEventListener(this.eventName, this.handleEvent.bind(this));
    }
    handleToastOpen(toast) {
        if (!toast) {
            return;
        }
        const handler = setTimeout(this.closeToast.bind(this, toast, true), toast.dismissTimeout * 1000);
        this.toasts[toast.id] = new toast_handler_item_model_1.ToastHandlerItemModel(toast, handler);
        this.uiOpenToast(toast);
    }
    getToastById(toastId) {
        const item = this.toasts[toastId];
        if (!item) {
            return undefined;
        }
        return item.toast;
    }
    closeToast(toast, timeoutHit) {
        if (!toast) {
            return;
        }
        const toastItem = this.toasts[toast.id];
        if (!toastItem) {
            return;
        }
        if (!timeoutHit && !!toast.dismissAction) {
            if (typeof toast.dismissAction === 'function') {
                const dismissCallback = toast.dismissAction;
                const result = dismissCallback(toast);
                if (!result) {
                    this.dismissToast(toastItem);
                }
                return;
            }
            else if (!!toast.dismissAction) {
                try {
                    const url = new URL(toast.dismissAction);
                    clearTimeout(toastItem.handler);
                    window.location.href = url.href;
                }
                catch (e) {
                }
            }
        }
        this.dismissToast(toastItem);
    }
    clickToast(toast) {
        if (!toast) {
            return;
        }
        const toastItem = this.toasts[toast.id];
        if (!toastItem) {
            return;
        }
        if (!!toast.clickAction) {
            if (typeof toast.clickAction === 'function') {
                const clickCallback = toast.clickAction;
                const result = clickCallback(toast);
                if (!!result) {
                    this.dismissToast(toastItem);
                }
                return;
            }
            try {
                this.dismissToast(toastItem);
                const url = new URL(toast.clickAction);
                if (toast.clickTarget !== '_self') {
                    window.open(url.href, '_blank');
                }
                else {
                    window.location.href = url.href;
                }
            }
            catch (e) {
            }
        }
    }
    handleEvent(event) {
        if (!(event === null || event === void 0 ? void 0 : event.detail)) {
            return;
        }
        const toast = event.detail;
        if (!toast) {
            return;
        }
        this.handleToastOpen(toast);
    }
    dismissToast(toastItem) {
        clearTimeout(toastItem.handler);
        this.uiCloseToast(toastItem.toast);
    }
}
exports.ToastsHandlerBase = ToastsHandlerBase;
//# sourceMappingURL=toasts-handler-base.js.map